import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function GradesGrid(props) {
    const { arrayGrades, clickDelete, userPermissions } = props;

    // Helper for date formatting
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    // Helper for quantity formatting
    const formatarQtde = (qtde) => qtde ? Number(qtde).toLocaleString('pt-BR') : '0';

    if (!arrayGrades || arrayGrades.length === 0) {
        return (
            <div className="text-center p-5 text-muted">
                <i className="fas fa-th fa-3x mb-3 text-secondary"></i>
                <h3 className="empty-title">Nenhuma grade encontrada</h3>
                <p className="empty-description">
                    Não há grades cadastradas ou que correspondam aos critérios da sua pesquisa.
                </p>
            </div>
        );
    }

    return (
        <div className="table-responsive">
            <table className="table table-custom table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '120px' }}>Ações</th>
                        <th className="text-start">Descrição da Grade</th>
                        <th className="text-start">Qtde. Total</th>
                        <th className="text-start">Data Cadastro</th>
                        <th className="text-start">Usuário Cadastro</th>
                        <th className="text-start">Data Alteração</th>
                        <th className="text-start">Usuário Alteração</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayGrades.map(grade => (
                        <tr key={grade.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <Link
                                        to={`/app/editargrade/${grade.id}`}
                                        className="btn-action-sm btn-edit"
                                        title="Editar"
                                        onClick={(e) => {
                                            // Validation for Edit
                                            if (userPermissions && userPermissions['editar_grades'] === false) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                    <button onClick={() => clickDelete(grade.id)} className="btn-action-sm btn-delete" title="Excluir"><i className="fas fa-trash"></i></button>
                                </div>
                            </td>

                            <td data-label="Descrição da Grade">{grade.descricao}</td>
                            <td data-label="Qtde. Total">{formatarQtde(grade.quantidade_total)}</td>
                            <td className="small text-muted" data-label="Data Cadastro">{formatDate(grade.data_cadastro)}</td>
                            <td className="small" data-label="Usuário Cadastro">{grade.usuario_cadastro_nome || '-'}</td>
                            <td className="small text-muted" data-label="Data Alteração">{formatDate(grade.data_ultima_alteracao)}</td>
                            <td className="small" data-label="Usuário Alteração">{grade.usuario_alteracao_nome || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GradesGrid;